export default "__VITE_ASSET__BEjtdTzN__"